import { createContext, useContext, type ReactNode } from "react";
import type { CheckoutApi } from "./types";

const ApiContext = createContext<CheckoutApi | null>(null);

export function ApiProvider({ api, children }: { api: CheckoutApi; children: ReactNode }) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): CheckoutApi {
  const api = useContext(ApiContext);
  if (!api) throw new Error("useApi outside <ApiProvider>");
  return api;
}
